import fr from '@/router/lang/localized_urls/fr.json';

export default { fr };
